import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import './service/css/Acp.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Home from './service/Home';
import Clientes from './service/Clientes';
import Usuarios from './service/Usuarios';
import UnidadesMedidas from './service/UnidadesMedidas';
import LoginPage from './service/LoginPage';
import LoginPageDefault from './service/LoginPageDefault';
import ForgotPasswordPage from './service/ForgotPasswordPage';
import SelecionaEntidade from './service/SelecionaEntidade';
import Requisitantes from './service/Requisitantes';
import UsuariosVinculos from './service/UsuariosVinculos';
import UploadImagem from './service/UploadImagem';
import Relatorios from './service/Relatorios';
import Pca from './service/Pca';
import PcaDocx from './service/PcaDocx';
import MarginsList from './service/MarginsList';
import Pncp from './service/Pncp';
import PcaConsolidacao from './service/PcaConsolidacao';
import PcaConsolidado from './service/PcaConsolidado';
import PcaItensConsolidados from './service/PcaItensConsolidados';
import AprovaDfd from './service/AprovaDfd';
import AprovaDfdItens from './service/AprovaDfdItens';
import DfdItens from './service/DfdItens';
import Dfds from './service/Dfds';
import PcaItens from './service/PcaItens';
import DfdLotes from './service/DfdLotes';
import DfdLoteItens from './service/DfdLoteItens';
import CatmatImport from './service/CatmatImport';
import CatmatUmImport from './service/CatmatUmImport';
import CatserImport from './service/CatserImport';
import CatserUmImport from './service/CatserUmImport';
import TiposObjetos from './service/TiposObjetos';
import Responsabilidades from './service/Responsabilidades';
import { SidebarProvider } from './service/context/SidebarContext';

import ProtectedRoute from './ProtectedRoute';
import SessionsAtivas from './service/SessionsAtivas';

function App() {
  return (
    <Router>
      <SidebarProvider>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/login_default" element={<LoginPageDefault />} />
          <Route path="/esqueci-senha" element={<ForgotPasswordPage />} />
          <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
          <Route path="/clientes" element={<ProtectedRoute><Clientes /></ProtectedRoute>} />
          <Route path="/requisitantes" element={<ProtectedRoute><Requisitantes /></ProtectedRoute>} />
          <Route path="/responsabilidades" element={<ProtectedRoute><Responsabilidades /></ProtectedRoute>} />
          <Route path="/usuarios" element={<ProtectedRoute><Usuarios /></ProtectedRoute>} />
          <Route path="/seleciona_entidade" element={<ProtectedRoute><SelecionaEntidade /></ProtectedRoute>} />
          <Route path="/upload_imagem" element={<ProtectedRoute><UploadImagem /></ProtectedRoute>} />
          <Route path="/usuario_vinculos" element={<ProtectedRoute><UsuariosVinculos /></ProtectedRoute>} />
          <Route path="/dfd_itens" element={<ProtectedRoute><DfdItens /></ProtectedRoute>} />
          <Route path="/dfds" element={<ProtectedRoute><Dfds /></ProtectedRoute>} />
          <Route path="/relatorios" element={<ProtectedRoute><Relatorios /></ProtectedRoute>} />
          <Route path="/pca_itens" element={<ProtectedRoute><PcaItens /></ProtectedRoute>} />
          <Route path="/pca" element={<ProtectedRoute><Pca /></ProtectedRoute>} />
          <Route path="/pca_docx" element={<ProtectedRoute><PcaDocx /></ProtectedRoute>} />
          <Route path="/pca_consolidacao" element={<ProtectedRoute><PcaConsolidacao /></ProtectedRoute>} />
          <Route path="/pca_consolidado" element={<ProtectedRoute><PcaConsolidado /></ProtectedRoute>} />
          <Route path="/pca_itens_consolidados" element={<ProtectedRoute><PcaItensConsolidados /></ProtectedRoute>} />
          <Route path="/pncp" element={<ProtectedRoute><Pncp /></ProtectedRoute>} />
          <Route path="/aprova_dfd" element={<ProtectedRoute><AprovaDfd /></ProtectedRoute>} />
          <Route path="/aprova_dfd_itens" element={<ProtectedRoute><AprovaDfdItens /></ProtectedRoute>} />
          <Route path="/dfd_lotes" element={<ProtectedRoute><DfdLotes /></ProtectedRoute>} />
          <Route path="/dfd_lote_itens" element={<ProtectedRoute><DfdLoteItens /></ProtectedRoute>} />
          <Route path="/unidades_medidas" element={<ProtectedRoute><UnidadesMedidas /></ProtectedRoute>} />
          <Route path="/catmat_import" element={<ProtectedRoute><CatmatImport /></ProtectedRoute>} />
          <Route path="/margens_config" element={<ProtectedRoute><MarginsList /></ProtectedRoute>} />
        <Route path="/catmat_um_import" element={<CatmatUmImport />} />
        <Route path="/catser_import" element={<CatserImport />} />
        <Route path="/catser_um_import" element={<CatserUmImport />} />
        <Route path="/tipos_objetos" element={<TiposObjetos />} />
          <Route path="/sessions_ativas" element={<ProtectedRoute><SessionsAtivas /></ProtectedRoute>} />
        </Routes>
      </SidebarProvider>
    </Router>
  );
}

export default App;
